import type { AnomalyDefinition, Employee, MailTemplate, StoryEvent } from "../types";

export interface ValidationIssue {
  level: "error" | "warning";
  source: string;
  message: string;
}

export function validateCatalogs(
  employees: Employee[],
  mails: MailTemplate[],
  anomalies: AnomalyDefinition[],
  storyEvents: StoryEvent[]
): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  const employeeIds = new Set(employees.map((item) => item.id));
  const mailIds = new Set(mails.map((item) => item.id));

  for (const mail of mails) {
    if (!employeeIds.has(mail.senderId)) {
      issues.push({ level: "error", source: mail.id, message: `Unknown sender: ${mail.senderId}` });
    }
    for (const id of [...mail.toIds, ...mail.ccIds]) {
      if (!employeeIds.has(id)) {
        issues.push({ level: "error", source: mail.id, message: `Unknown recipient: ${id}` });
      }
    }
    if (!mail.subject.trim() || !mail.body.trim()) {
      issues.push({ level: "error", source: mail.id, message: "Subject and body are required." });
    }
    if (mail.allowedPhases.length === 0) {
      issues.push({ level: "warning", source: mail.id, message: "No allowed phases." });
    }
  }

  for (const anomaly of anomalies) {
    if (anomaly.apply.senderId && !employeeIds.has(anomaly.apply.senderId)) {
      issues.push({ level: "error", source: anomaly.id, message: `Unknown anomaly sender: ${anomaly.apply.senderId}` });
    }
    for (const id of [...(anomaly.apply.addToIds ?? []), ...(anomaly.apply.addCcIds ?? [])]) {
      if (!employeeIds.has(id)) {
        issues.push({ level: "error", source: anomaly.id, message: `Unknown anomaly recipient: ${id}` });
      }
    }
  }

  for (const event of storyEvents) {
    if (event.action.forceMailId && !mailIds.has(event.action.forceMailId)) {
      issues.push({ level: "error", source: event.id, message: `Unknown forced mail: ${event.action.forceMailId}` });
    }
  }

  return issues;
}
